import type { AnyAction } from 'redux';

import { SET_INITIAL_DATA, SET_PANEL_STATE } from './actions';
import type { A11yWizardState } from './types';

const initialState: A11yWizardState = {
  initialData: {
    rulesData: undefined,
    lastScanTimeStamp: undefined,
  },
  panelState: undefined,
};

export const a11yWizardReducer = (
  state: A11yWizardState = initialState,
  action: AnyAction,
): A11yWizardState => {
  switch (action.type) {
    case SET_INITIAL_DATA:
      return {
        ...state,
        initialData: { ...action.value },
      };
    case SET_PANEL_STATE:
      return {
        ...state,
        panelState: { ...action.value },
      };
    default:
      return state;
  }
};
